module.exports = __webpack_public_path__ + "static/media/class.21e37202.svg";